import { Box, Paper, Table as MuiTable, TableContainer } from '@mui/material';
import React from 'react';
import { ColumnDefinitionType } from './table.utils';
import { TableHeaders } from './TableHeaders';
import { ITablePaginationProps, TablePagination } from './TablePagination';
import { TableRows } from './TableRows';
import { useListPagePaper } from '../ListPagePaper';

interface ITableProps<T extends object> {
  data: Array<T>;
  columns: ColumnDefinitionType<T>[];
  additionalData: object;
  sortBy?: keyof T;
  sort?: 'desc' | 'asc';
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  pagination?: ITablePaginationProps;
  maxHeight?: number;
  fillAvailableHeight?: boolean;
  selected?: string[];
  selectedKey?: keyof T;
  // eslint-disable-next-line no-unused-vars
  onSelectAll?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line no-unused-vars
  onItemClick?: (event: React.MouseEvent<unknown>, id: string) => void;
}

export function Table<T extends object>({
  data,
  columns,
  additionalData,
  sortBy,
  sort,
  onSort,
  pagination,
  maxHeight = 570,
  fillAvailableHeight = false,
  selected,
  selectedKey,
  onSelectAll,
  onItemClick,
}: ITableProps<T>) {
  const isInsideListPagePaper = useListPagePaper();
  const shouldFillAvailableHeight =
    fillAvailableHeight || isInsideListPagePaper;

  return (
    <Box
      sx={{
        display: 'flex',
        flex: shouldFillAvailableHeight ? 1 : undefined,
        flexDirection: 'column',
        minHeight: 0,
        width: '100%',
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 'none',
          flex: shouldFillAvailableHeight ? 1 : undefined,
          maxHeight: shouldFillAvailableHeight ? undefined : maxHeight,
          minHeight: 0,
          overflow: shouldFillAvailableHeight ? 'auto' : undefined,
        }}
      >
        <MuiTable size="small" stickyHeader>
          <TableHeaders
            columns={columns}
            sortBy={sortBy}
            sort={sort}
            onSort={onSort}
            rowCount={data.length}
            numSelected={selected?.length}
            onSelectAll={onSelectAll}
          />
          <TableRows
            data={data}
            columns={columns}
            additionalData={additionalData}
            selected={selected}
            selectedKey={selectedKey}
            onItemClick={onItemClick}
          />
        </MuiTable>
      </TableContainer>
      {pagination ? <TablePagination {...pagination} /> : null}
    </Box>
  );
}
